import { cn } from "@/lib/utils";

/**
 * Sage square that visually replaces a sentence-ending period. Rhymes with the
 * heatmap cell (rounded-[2px], same sage) and the logo mark. The literal
 * period is kept for screen readers so the sentence still parses.
 */
export function SagePeriod({ className }: { className?: string }) {
  return (
    <>
      <span className="sr-only">.</span>
      <span
        aria-hidden="true"
        className={cn(
          "ml-[0.08em] inline-block translate-y-[-0.02em] rounded-[1px] bg-primary align-baseline",
          className,
        )}
        style={{ width: "0.18em", height: "0.18em" }}
      />
    </>
  );
}
